

export class TemperatureCalibrationStatusInput implements ITemperatureCalibrationStatusInput {
    /** The auto-generated id of the temperature calibration master */
    temperatureCalibrationId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: ITemperatureCalibrationStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.temperatureCalibrationId = _data["temperatureCalibrationId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TemperatureCalibrationStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureCalibrationStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temperatureCalibrationId"] = this.temperatureCalibrationId;
        data["status"] = this.status;
        return data; 
    }
}

export interface ITemperatureCalibrationStatusInput {
    /** The auto-generated id of the temperature calibration master */
    temperatureCalibrationId: number;
    /** The updated status */
    status: number;
}

